import React, { Fragment, useEffect, useState } from "react";

import Commments from "../Comments/Comments";
import classes from "../AcitvityPosts.module.css";
import BuyOptions from "../BuyOptions/BuyOptions";
import * as actionCreators from "../../../../Store/actions/index";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
const ExtraElemnts = (props) => {
  const [showComments, setShowComments] = useState(false);
  const [buyMode, setBuyMode] = useState("");
  const [showbuyOption, setShowbuyOption] = useState(false);
  const history = useHistory();
  const location = useLocation();

  const getModeratorCmmments = () => {
    if (props.comments) {
      if (
        props.postState === "reviewed" &&
        showComments &&
        +props.comments.vehicle_list_id !== +props.post.id
      ) {
        props.onGetModeratorComments(props.post.id);
      }
    } else {
      if (props.postState === "reviewed" && showComments) {
        props.onGetModeratorComments(props.post.id);
      }
    }
  };

  useEffect(getModeratorCmmments, [showComments]);

  const buyModeHandler = (mode) => {
    let type = null;
    type = isNaN(parseInt(mode));
    if (type) {
      setBuyMode(mode);
      setShowbuyOption(true);
    } else setShowbuyOption(false);
  };

  let extraElements = null;
  switch (props.postState) {
    case "published":
      extraElements = (
        <Fragment>
          <div className={classes.BtnGroup}>
            <button
              value="feature"
              className={
                buyMode === "feature" ? classes.Chosed : classes.PublishedBtns
              }
              onClick={(event) => buyModeHandler(event.target.value)}
            >
              Unlock feature
            </button>
            <button
              value="fast_deal"
              className={
                buyMode === "fast_deal" ? classes.Chosed : classes.PublishedBtns
              }
              onClick={(event) => buyModeHandler(event.target.value)}
            >
              Unlock fast deals
            </button>
            <button
              value="bump"
              className={
                buyMode === "bump" ? classes.Chosed : classes.PublishedBtns
              }
              onClick={(event) => buyModeHandler(event.target.value)}
            >
              Unlock bumb
            </button>
          </div>
          {showbuyOption && (
            <BuyOptions
              buyModeHandler={buyModeHandler}
              postId={props.post.id}
              vehicleType={props.post.vehicle_type}
              purchaseType={buyMode}
              postState={props.postState}
            />
          )}
          <button
            className={classes.PublishedBtnsExpand}
            onClick={(event) => {
              setShowComments(!showComments);
            }}
          >
            {showComments ? "collapse" : "expand"} user comments
          </button>

          {showComments && (
            <Commments comments={props.post} postState={props.postState} />
          )}
        </Fragment>
      );
      break;
    case "reviewed":
      extraElements = (
        <Fragment>
          <button
            style={{ margin: "1% 30%" }}
            className={classes.PublishedBtns}
            type="button"
            onClick={(event) => {
              props.onGetPostToEdit(props.post.id);
              localStorage.setItem("draftId", props.post.id);
              history.push("/Edit", { postMode: "reviewed" });
            }}
          >
            Edit
          </button>
          <button
            className={classes.PublishedBtnsExpand}
            onClick={(event) => setShowComments(!showComments)}
          >
            {showComments ? "collapse" : "expand"} user comments
          </button>
          {showComments && props.comments[`comments_${props.post.id}`] && (
            <Commments
              comments={props.comments[`comments_${props.post.id}`]}
              postState={props.postState}
              vihecleId={props.post.id}
            />
          )}
        </Fragment>
      );
      break;
    case "onHold":
      extraElements = (
        <button
          style={{ margin: "1% 30%" }}
          className={classes.PublishedBtns}
          type="button"
          onClick={(event) => {
            localStorage.removeItem("draftId");
            props.onViewPost(props.post.id);
            history.push("/Preview", {
              prevPath: location.pathname,
            });
          }}
        >
          View
        </button>
      );
      break;
    case "draft":
      extraElements = (
        <button
          style={{ margin: "1% 30%" }}
          className={classes.PublishedBtns}
          type="button"
          onClick={(event) => {
            props.onGetPostToEdit(props.post.id);
            localStorage.setItem("draftId", props.post.id);
            history.push("/Edit", { postMode: "draft" });
          }}
        >
          Edit
        </button>
      );
      break;
    default:
      break;
  }
  return extraElements;
};

const mpaStateToProps = (state) => {
  return {
    loadingComments: state.Activity.loadingModeratorComments,
    comments: state.Activity.comments,
    moderatorCommentError: state.Activity.moderatorCommentError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetPostToEdit: (postId) => {
      dispatch(actionCreators.getEditPost(postId));
    },
    onViewPost: (postId) => {
      dispatch(actionCreators.getPreviewPost(postId));
    },
    onGetModeratorComments: (postId) => {
      dispatch(actionCreators.getModeratorComments(postId));
    },
  };
};

export default connect(mpaStateToProps, mapDispatchToProps)(ExtraElemnts);
